import FormattedText from 'src/components/Chat/Messages/FormattedText/FormattedText';

interface ShareQuestionProps {
	userAnswer: string;
	botReply: string;
}

const ShareQuestion = ({ userAnswer, botReply }: ShareQuestionProps) => {
	return (
		<>
			<p className="user-answer">{userAnswer}</p>
			<p className="bot-reply">
				<FormattedText text={botReply} />
			</p>
		</>
	);
};

export default ShareQuestion;
